import { z } from "zod";

import { FormField } from "../../../FormEngine/types";
import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Weight Treatment History form schema
 *
 * This schema defines the fields for the Weight Treatment History form
 * using the FormEngine component.
 */
export const weightTreatmentHistorySchema: FormField[] = [
  {
    type: "multi-select-response",
    name: "medications",
    title: "Medications",
    description: "Have you taken any of the following medications for weight loss?",
    options: [
      "GLP-1 drugs (like Ozempic, Wegovy, or others)",
      "Phentermine (Adipex, Lomaira, Qsymia)",
      "Qsymia",
      "Orlistat",
      "Contrave",
      "Plenity",
      "Belviq",
      "Wellbutrin",
      "Metformin",
      "Topiramate",
      "Naltrexone",
      "Other",
    ].map((option) => ({ label: option, value: option })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Please describe",
      },
      {
        type: "input",
        name: "sideEffects",
        label: "Side effects",
      },
    ],
    fieldProps: {
      includeNoneOption: true,
    },
    rule: z.array(multiSelectResponseSchema).min(1, { message: "Please select at least one option" }),
  },
  {
    type: "multi-select-response",
    name: "lifestylePrograms",
    title: "Lifestyle Programs",
    description: "Have you tried any of the following lifestyle programs?",
    options: [
      "App-based program",
      "Packaged foods",
      "Exercise",
      "Clean eating",
      "Meal prepping",
      "Low fat",
      "Low carb/Atkins/keto/paleo",
      "Shakes",
      "Intermittent fasting",
      "Hypnosis",
      "Overeaters Anonymous",
      "Nutrition counseling/dietitian/health coaching",
      "Vitamins/supplements",
      "Other",
    ].map((option) => ({ label: option, value: option })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Please describe",
      },
    ],
    fieldProps: {
      includeNoneOption: true,
    },
    rule: z
      .array(multiSelectResponseSchema)
      .min(1, { message: "Please select at least one option" }),
  },
  {
    type: "multi-select",
    name: "priorSurgeriesOrProcedures",
    title: "Procedures or Surgeries",
    description: "Have you had any of the following surgeries or procedures?",
    options: [
      "Gastric bypass surgery",
      "Gastric sleeve surgery",
      "Lap band",
      "Gastric balloon",
      "Liposuction",
      "Tummy tuck",
      "Laser treatment",
    ].map((option) => ({ label: option, value: option })),
    fieldProps: {
      includeOtherOption: true,
      includeNoneOption: true,
    },
    rule: z.array(z.string()).min(1, { message: "Please select at least one option" }),
  },
  {
    type: "multi-select-response",
    name: "logging",
    title: "Logging",
    description: "Do you keep a food journal or exercise log?",
    options: ["Food Journal", "Exercise Log"].map((option) => ({ label: option, value: option })),
    schema: [
      {
        type: "input",
        name: "description",
        label: "Description (eg, how long, how often, etc.)",
      },
    ],
    fieldProps: {
      includeNoneOption: true,
    },
    rule: z
      .array(multiSelectResponseSchema)
      .min(1, { message: "Please select at least one option" }),
  },
];

export default weightTreatmentHistorySchema;
